import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { CompleteAnim, MplButton } from '@mopla/ui';

import { usePaymentPortalControls } from '../../utils';

const DialogRoot = styled('div')(() => ({
	display: 'grid',
	placeContent: 'center',
	background: '#00000070',
	position: 'fixed',
	bottom: 0,
	left: 0,
	top: 0,
	right: 0,
	zIndex: 1300 /**above modals */,
}));

const Dialog = styled('div')(({ theme }) => ({
	background: theme.palette.neutral[0],
	width: 'calc(100vw - 16px)',
	maxWidth: 500,
	display: 'grid',
	gridGap: 24,
	gridAutoFlow: 'row',
	padding: '16px',
	boxSizing: 'border-box',
	overflowY: 'auto',
	borderRadius: '8px',
}));

export const SuccessStep = () => {
	const { t } = useTranslation('openBanking');
	const { closePaymentPortal } = usePaymentPortalControls();

	return (
		<DialogRoot>
			<Dialog>
				<CompleteAnim />
				<Box display="flex" flexDirection={'column'} alignItems={'center'}>
					<Typography sx={{ marginTop: '8px' }} variant="bodyTitle">
						{t('success')}
					</Typography>
				</Box>
				<MplButton
					testId="SuccessStep-CloseButton"
					onClick={closePaymentPortal}
				>
					{t('button.close')}
				</MplButton>
			</Dialog>
		</DialogRoot>
	);
};
